import { render } from "./TwilioModalBody.vue?vue&type=template&id=32459c4e&scoped=true"
import script from "./TwilioModalBody.vue?vue&type=script&lang=js"
export * from "./TwilioModalBody.vue?vue&type=script&lang=js"

import "./TwilioModalBody.vue?vue&type=style&index=0&id=32459c4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32459c4e"]])

export default __exports__